<template>
  <ul>
    <li class="pager prev" @click="changePage(currentPage-1)" :disabled="currentPage <= 1">
      <ct-icon name="jiantouyou" class="rotate"></ct-icon>
    </li>
    <li
     class="pager"
     v-for="i in total"
     :key="i"
     :class="i === currentPage ? 'active':''"
     @click="changePage(i)">
     {{i}}
     </li>
    <li
     class="pager next"
     @click="changePage(currentPage+1)" :disabled="currentPage >= total">
      <ct-icon name="jiantouyou"></ct-icon>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'VPagination',
  props: {
    total: Number,
    page: Number
  },
  data () {
    return {
      index: 0
    }
  },
  computed: {
    currentPage () {
      return this.index || this.page
    }
  },
  methods: {
    changePage (page) {
      if (page > this.total || page < 1) {
        return false
      } else {
        this.index = page
        this.$emit('change-page', page)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
  .rotate{
    transform: rotate(180deg);
  }
  .pager{
    display: inline-block;
    vertical-align: middle;
    font-size:13px;
    font-family:DINPro-Medium;
    font-weight:500;
    color:rgba(186,196,206,1);
    line-height:17px;
    text-align: center;
    cursor: pointer;
    margin-left: 8px;
    min-width: 16px;
    &[disabled]{
      cursor: not-allowed;
    }
  }
  .active {
    color: #fff;
    background: $secondary;
    border-radius:2px;
  }
  .prev, .next{
    font-size: 16px;
    color: $secondary;
    &[disabled=disabled]{
    color: #DAE0E5;
    }
  }
</style>
